let app = document.getElementById('app')

// /!\ les paramètres externes doivent être en minuscule
let preferences = {
    vueAppBackendUrl:
        app.getAttribute('vueappbackendurl') || process.env.VUE_APP_BACKEND_URL,
    vueAppBaseUrl:
        app.getAttribute('vueappbaseurl') || process.env.VUE_APP_BASE_URL,
    vueAppMapboxAccessToken:
        app.getAttribute('vueappmapboxaccesstoken') ||
        process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
    vueAppBingKey:
        app.getAttribute('vueappbingkey') || process.env.VUE_APP_BING_KEY,
    lang: app.getAttribute('lang') || process.env.VUE_APP_I18N_LOCALE,

    vueAppFirebaseCloudMessaging:
        app.getAttribute('vueappfirebasecloudmessaging') ||
        process.env.VUE_APP_FIREBASE_CLOUD_MESSAGING,

    vueAppUrlSignaler:
        app.getAttribute('page') || process.env.VUE_APP_URL_SIGNALER,
    vueAppThemeColor:
        app.getAttribute('vueappthemecolor') || process.env.VUE_APP_THEME_COLOR,
    vueAppSecondaryColor:
        app.getAttribute('vueappsecondarycolor') ||
        process.env.VUE_APP_SECONDARY_COLOR,
    vueAppTertiaryColor:
        app.getAttribute('vueapptertiarycolor') ||
        process.env.VUE_APP_TERTIARY_COLOR,
    vueAppStandAlone:
        app.getAttribute('vueappstandalone') ||
        process.env.VUE_APP_STANDALONE == 'true'
}

console.log('standalone ? ' + preferences.vueAppStandAlone)

export default preferences
